import { FormLabel, FormControl, FormHelperText, Textarea as ChakraTextarea } from "@chakra-ui/react";
import type { FormControlProps } from "..";

const Textarea = ({
  errors,
  name,
  label,
  placeholder,
  register,
  disabled,
  helperText,
  required,
  mb = 6,
}: FormControlProps) => (
  <FormControl isInvalid={errors[name]} isDisabled={disabled} id={name} isRequired={required}>
    <FormLabel htmlFor={name} fontWeight="semibold" mb={2}>
      {label}
    </FormLabel>
    <ChakraTextarea name={name} placeholder={placeholder} ref={register} mb={mb} resize="none" rows={5} />
    {helperText && <FormHelperText color="greyscale.500">{helperText}</FormHelperText>}
  </FormControl>
);
export default Textarea;
